import { useEffect, useRef } from "react";

export type OnUnmount = () => void;

export const useRunOnUnmount = (onUnmount: OnUnmount): void => {
    const onUnmountRef = useRef<OnUnmount>(onUnmount);

    useEffect(() => {
        onUnmountRef.current = onUnmount;
    }, [onUnmount]);

    useEffect(
        () => () => {
            const { current } = onUnmountRef;

            if (current == null || typeof current !== "function") {
                return;
            }

            current();
        },
        []
    );
};
